






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MessageThread, MessageThreadSubjectTypeEnum } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { timeAgo } from "@/lib/time";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import MessagePreview from "@/components/MessagePreview";
import PageTitle from "@/components/PageTitle";

@Component({ name: "MessageThreadItem", components: { MessagePreview, BasePage, BaseIcon, PageTitle, BaseAvatar } })
export default class MessageThreadItem extends Vue {
  @Prop({ required: true })
  public messageThread!: MessageThread;

  @Prop({ type: String, required: true })
  public authUserId!: string;

  @Prop({ type: Number, required: true })
  public subscriberCost!: number;

  public get isBroadcast() {
    return (
      MessageThreadSubjectTypeEnum.BROADCAST_MEMBER === this.messageThread.subject.subjectType ||
      MessageThreadSubjectTypeEnum.BROADCAST_CREATOR === this.messageThread.subject.subjectType
    );
  }

  public get to() {
    if (this.isBroadcast) {
      const threadId = this.messageThread.id;
      return { name: "generalMessageThread", params: { threadId } };
    }
    const userId = this.messageThread.userIds.find(i => i !== this.authUserId) || this.authUserId;
    return { name: "messages", params: { userId } };
  }

  public get user() {
    if (this.isBroadcast) {
      return this.messageThread.users[0];
    }
    return (
      this.messageThread?.users.find(i => i.id !== this.authUserId) ??
      this.messageThread?.users.find(i => i.id === this.authUserId)
    );
  }

  public get screenName() {
    if (this.isBroadcast) {
      return this.messageThread.users[0].screenName;
    }
    return this.user?.screenName ?? "";
  }

  public get timeData() {
    return timeAgo(this.messageThread.updatedTime);
  }
}
